/**
 * Core
 */
import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Components
 */
import Footer from '../components/footer'


/**
 * Hooks
 */
import useScrollTrigger from '../hooks/scroll-trigger.hook'
import finalists_data from '../finalists_data.json'


const FinalistsAnnounced = () => {

    useScrollTrigger('.reveal')
  
    
    return (
        <>
            <section className='bg-white text-ai-gray-900 py-16'>
                <div>
                    <h1 className='self-center bg-gradient-analagous-rose-triad-orange'>Finalists Announced</h1>
                </div>
            </section>
            <section className='bg-gradient-pastel text-ai-gray-900 pt-16'>
                <div>
                    <p className='reveal top'>It's the moment we've all been waiting for - the UK Customer Experience Awards (CXA) finalists have been announced! This year's competition has seen some of the highest quality submissions to date, and it's clear that everyone is eager to show off their initiatives, improvements, and outright customer wins!</p>
                    <p className='reveal top'>The CXA team have whittled down hundreds of entries to select the very best, and we can't wait to get down to Wembley Stadium on the 16th of October for the awards finals.</p>
                    <p className='reveal top'>We'll be there in force as we celebrate those who have gone above and beyond in providing stellar customer experience - from small startups right through to international brands. It's sure to be an evening filled with glamour, laughter, and a whole lot of fun. </p>
                    <p className='reveal top'>We know you're as excited as we are about the upcoming awards ceremony, so make sure to keep your eyes locked on the CXA website for all the latest news and updates. In the meantime, congratulations to those who have made it through to the finals - this is an incredible achievement!"</p>
                    
                        <div>
                            <div className='reveal top'>
                                <button className='dark self-start'>
                                    <Link to={`/book-now`}>
                                        <div>Book Seats</div>
                                    </Link>
                                </button>
                            </div>
                        </div>
                    
                </div>
            </section>

            <section className='bg-white text-ai-gray-900'>
                <div>
                {finalists_data.finalists.map((item, index) => (
                    <div key={index}>
                        <h3 className='text-cxa_primary text-center mb-10 mt-10' key={index}>{item.category}</h3>
                    
                    <div className='container mx-auto content-box flex flex-col md:grid grid-cols-3'>
                    {item.companies.map((company, idx) => (
                        <div className='flex flex-col justify-center items-center mb-10 text-center'>
                        {company.logo && (
                            <div className='rounded-xl flex justify-center p-5 shadow-xl'>
                                <img
                                src={company.logo}
                                alt={company.name}
                                style={{ width: "250px", height: "150px", objectFit: "contain" }}
                                />
                            </div>
                          )}
                        <p className='h-24' key={idx}>{company.name}</p>
                        </div>
                    ))}
                    </div>
                    </div>
                ))}       
                </div>
      
            </section> 
            <section className='pb-0 border-t border-t-ai-gray-800'>
                <Footer />
            </section>
        </>
    )
}

export default FinalistsAnnounced